export { default as ThreeDStockMaterialsContent } from './ThreeDStockMaterialsContent';
